<style lang="scss" scoped>
.uc-connections {
    border: 1px solid #4b8df8;
    margin-bottom: 15px;
    &-title {
        line-height: 40px;
        background-color: #4b8df8;
        color: #fff;
        padding: 0 15px;
    }
    &-content {
        .uc-item {
            border-bottom: 1px solid #ccc;
            padding: 5px 10px;
            margin: 0;
        }
    }
}
.uc-connections ul.myconnect {
    list-style: none;
}
// .uc-connections ul.myconnect li {
//     display: inline;
// }
.login-content {
    display: flex;

    .social-login-false {
        width: 100%;
        font-size: 14px;
        text-align: center;
        padding: 15px 0;
    }
}
.myconnect {
    // display: flex;
    position: relative;
    padding: 15px;
    margin: 15px 0;
    // justify-content: center;
    &::after {
        content: "";
        position: absolute;
        width: 1px;
        background-color: #dddddd;
        top: 0;
        right: 0;
        bottom: 0;
    }

    .last-button {
        position: absolute;
        bottom: 0;
    }
    .common-li {
        display: block;
        position: relative;
        padding: 20px;
        // margin-right: 20px;
        img {
            // display: block;
            // margin: 0 auto;
            display: inline-block;
            vertical-align: middle;
            width: 25px;
            margin-bottom: 5px;
            margin-right: 10px;
        }
        .title {
            display: inline-block;
            margin-bottom: 15px;
            font-size: 16px;
            margin-right: 15px;
        }
        .user-name {
            display: inline-block;
            vertical-align: middle;
            span {
                margin-right: 15px;
            }
        }
    }
}
.qr-code-container {
    flex: 1;
    text-align: center;
}
</style>
<template>
    <div>
        <Bread v-bind="bread" />
        <div class="uc-connections">
            <div v-if="auto">
                <Spin
                    size="large"
                    fix
                    style="
                        background-color: rgba(255, 255, 255, 0.6);
                        font-size: 14px;
                    "
                >
                    <span
                        class="ivu-spin-dot"
                        style="display: block; margin: auto"
                    ></span>
                    {{ loadingText }}
                </Spin>
            </div>
            <h3 class="uc-connections-title">
                <Icon type="ios-contacts" size="16"></Icon>
                {{ $t("port.connections.title") }}
            </h3>
            <div class="login-content">
                <ul v-if="showSocialLogin" class="myconnect unstyled">
                    <li
                        :class="`common-li ${item.id}`"
                        v-for="item in socialLoginButtons"
                        :key="item.id"
                    >
                        <img
                            :src="item.img_sm"
                            :alt="$t(`port.connections.source_${item.id}`)"
                        />
                        <div class="title">
                            {{ $t(`port.connections.source_${item.id}`) }}:
                        </div>
                        <div
                            class="user-name"
                            v-if="connectionsMap.source[item.id].bound === true"
                        >
                            <span
                                >{{
                                    connectionsMap.source[item.id].nickname
                                }}
                                ({{
                                    connectionsMap.source[item.id].username
                                }})</span
                            >
                            <Button
                                @click="disconnectSocialAccount(item.id)"
                                type="default"
                                icon="ios-close-circle-outline"
                                >{{
                                    $t("port.connections.action_disconnect")
                                }}</Button
                            >
                        </div>
                        <div class="user-name" v-else>
                            <Button
                                @click="connectSocialAccount(item.id)"
                                type="primary"
                                icon="ios-link"
                                >{{
                                    $t("port.connections.action_connect")
                                }}</Button
                            >
                        </div>
                    </li>
                </ul>
                <div class="social-login-false" v-else>
                    暂无可用的社交登录通道
                </div>
                <div
                    class="qr-code-container"
                    v-show="showConnectAuthCode"
                    ref="connect_container"
                    id="connect_container"
                ></div>
            </div>
            <!-- <div class="text-center">
            <Button class="margin-10" type="default" @click="$router.push({name:'panel'})">{{$t('port.password.home')}}</Button>
		</div> -->
        </div>
    </div>
</template>

<script>
import Bread from "@/components/bread";
import { mapState } from "vuex";
import Cookies from "js-cookie";
import {
    HttpSocialAuthBound,
    HttpSocialAuthCallback,
    HttpSocialAuthRender,
    HttpSocialAuthUnbindSource,
    HttpUserInfo,
    SOCIAL_VENDOR_DINGTALK,
    SOCIAL_VENDOR_WECHAT,
} from "@mods/service/base";
import util from "../../utils/index";
import BrowserType from "@mods/utils/browser-type";
import { SOCIAL_VENDOR_QLINYUN,SOCIAL_VENDOR_QLINYUNDEV } from "@mods/service/base";
export default {
    components: {
        Bread,
    },
    data() {
        const connectUrlPrefix =
            window.location.protocol + "//" + window.location.host;
        const browserType = BrowserType();
        return {
            auto: true,
            loadingText: this.$t("port.connections.loading"),
            browserType: browserType,
            connectUrlPrefix: connectUrlPrefix,
            showConnectAuthCode: false,
            connectAuthRenderData: {},
            connectionsMap: {
                source: {
                    dingtalk: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                    wechat: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                    qlinyun: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                    qlinyundev: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                    wechat_open: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                    wechat_mp: {
                        bound: false,
                        nickname: "",
                        username: "",
                    },
                },
            },
            // 是否展示社交登录
            showSocialLogin: util.checkSocialLogin(window.location.hostname),
            // 社交登录的按钮数组
            socialLoginButtons: util.getAvailableSourcesByHost(
                window.location.hostname
            ),
        };
    },
    mounted() {},
    async created() {
        if (this.$route.query.connect) {
            this.auto = true;
            let authCallbackParams = {};
            if (this.$route.query.service) {
                authCallbackParams.service = this.$route.query.service;
            }
            if (!!Cookies.get("token")) {
                authCallbackParams.bindToken = Cookies.get("token");
            }
            if (this.$route.query.code) {
                authCallbackParams.code = this.$route.query.code;
            }
            if (this.$route.query.state) {
                authCallbackParams.state = this.$route.query.state;
            }
            if (this.$route.query.auth_code) {
                authCallbackParams.auth_code = this.$route.query.auth_code;
            }
            if (this.$route.query.authorization_code) {
                authCallbackParams.authorization_code = this.$route.query.authorization_code;
            }
            if (this.$route.query.oauth_token) {
                authCallbackParams.oauth_token = this.$route.query.oauth_token;
            }
            if (this.$route.query.oauth_verifier) {
                authCallbackParams.oauth_verifier = this.$route.query.oauth_verifier;
            }
            if (this.$route.query.tmp_auth_code) {
                authCallbackParams.tmp_auth_code = this.$route.query.tmp_auth_code;
            }
            if (this.$route.query.loginTmpCode) {
                authCallbackParams.loginTmpCode = this.$route.query.loginTmpCode;
            }

            let tempPam = this.$route.query.connect;

            switch (tempPam) {
                case SOCIAL_VENDOR_DINGTALK:
                case SOCIAL_VENDOR_QLINYUN:
                case SOCIAL_VENDOR_QLINYUNDEV:
                    {
                        // console.log("authCallbackParams", authCallbackParams);
                        let socialAuthCallbackResult = {};
                        await HttpSocialAuthCallback(
                            this.$route.query.connect,
                            window.location.host,
                            authCallbackParams
                        ).then(res => {
                            socialAuthCallbackResult = res;
                        }, err => {
                            socialAuthCallbackResult = err;
                        });
                        this.auto = false;
                        // console.log("socialAuthCallbackResult",socialAuthCallbackResult);
                        if (socialAuthCallbackResult.code === 200) {
                            if (
                                socialAuthCallbackResult.data.uid &&
                                socialAuthCallbackResult.data.uid > 0 &&
                                socialAuthCallbackResult.data.token
                            ) {
                                this.$Message.info({
                                    content: this.$t(
                                        "port.connections.action_connect_success"
                                    ),
                                    duration: 7,
                                });

                                this.connectionsMap.source[tempPam] = {
                                    bound: true,
                                    nickname:
                                        socialAuthCallbackResult.data
                                            .ucSocialUser.nickname,
                                    username:
                                        socialAuthCallbackResult.data
                                            .ucSocialUser.username,
                                };
                            } else {
                                this.$Message.warning({
                                    content:
                                        "当前三方账户尚未绑定平台账户请先用用户名密码登录后在用户资料中绑定后使用",
                                    duration: 7,
                                });
                            }
                        } else {
                            this.$Message.error({
                                content: socialAuthCallbackResult.message,
                                duration: 7,
                            });
                        }
                    }
                    break;
                default:
                    {
                        this.auto = false;
                        this.$Message.error("尚未完工，敬请期待");
                    }
                    break;
            }
        } else {
            await this.getUserSocialConnections();
            this.auto = false;
        }
    },
    computed: {
        ...mapState(["userinfo"]),
        bread() {
            let data = {};
            switch (this.lang) {
                case "en":
                    data = {
                        title: "Social Account Binding",
                        home: "Main Panel ",
                    };
                    break;
                default:
                    data = {
                        title: this.$t('port.profile.media_accounts',{defaultValue: "Binding of social media accounts"}),
                        home: this.$t('port.profile.main_panel',{defaultValue: "主面板"}),
                    };
                    break;
            }
            return data;
        },
    },
    methods: {
        getUserToken() {
            let token = Cookies.get("token");
            if (!!token) {
                return token;
            }
            return null;
        },
        getUserInfo() {
            HttpUserInfo().then((res) => {
                this.$store.commit("setUserInfo", res.data);
            });
        },
        async connectSocialAccount(source) {
            let vm = this;
            if (source) {
                this.auto = true;
                const callbackUrl = `${this.connectUrlPrefix}/home/connections?connect=${source}`;
                if (
                    source === SOCIAL_VENDOR_DINGTALK ||
                    source === SOCIAL_VENDOR_QLINYUN ||
                    source === SOCIAL_VENDOR_QLINYUNDEV
                ) {
                    // console.log('callbackUrl',callbackUrl);
                    try {
                        vm.connectAuthRenderData = await HttpSocialAuthRender(
                            source,
                            window.location.host,
                            encodeURIComponent(callbackUrl)
                        );
                    }
                    catch (err) {
                        vm.$Message.error({
                            content: err.message,
                            duration: 7,
                        });
                        return false;
                    }
                    // console.log('connectAuthRenderData',vm.connectAuthRenderData);
                    // console.log('connectAuthRenderData.redirectUri',vm.connectAuthRenderData.data.redirectUri);
                    if (vm.connectAuthRenderData.code === 200) {
                        if (source === SOCIAL_VENDOR_DINGTALK) {
                            if (
                                (vm.browserType.platform &&
                                    vm.browserType.platform === "mobile") ||
                                (vm.browserType.shell &&
                                    vm.browserType.shell ===
                                        SOCIAL_VENDOR_DINGTALK)
                            ) {
                                let url = encodeURIComponent(
                                    vm.connectAuthRenderData.data.redirectUri
                                );
                                let scope =
                                    vm.browserType.shell &&
                                    vm.browserType.shell ==
                                        SOCIAL_VENDOR_DINGTALK
                                        ? "snsapi_auth"
                                        : "snsapi_login";
                                let goto =
                                    `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                    url;
                                window.location.href = goto;
                                return true;
                            } else {
                                await this.$loadScript(
                                    "https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js"
                                );
                                this.showConnectAuthCode = true;
                                this.auto = false;
                                vm.$nextTick(() => {
                                    // console.log('vm.connectAuthRenderData.data.redirectUri ',vm.connectAuthRenderData.data.redirectUri);
                                    let url = encodeURIComponent(
                                        vm.connectAuthRenderData.data
                                            .redirectUri
                                    );
                                    // console.log('nexTick url',url);
                                    let goto = encodeURIComponent(
                                        `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=snsapi_login&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                            url
                                    );
                                    let obj = window.DDLogin({
                                        id: "connect_container", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
                                        goto: goto, //请参考注释里的方式
                                        style:
                                            "border:none;background-color:#FFFFFF;",
                                        width: "270",
                                        height: "300",
                                    });
                                    // 重置扫码登录框的样式，让登录框居中
                                    // let box = document.getElementById('login_container');
                                    // box.querySelector('iframe').style.position = 'absolute';
                                    // box.querySelector('iframe').style.top = '0';
                                    // box.querySelector('iframe').style.bottom = '0';
                                    // box.querySelector('iframe').style.left = '0';
                                    // box.querySelector('iframe').style.right = '0';
                                    // box.querySelector('iframe').style.margin = 'auto';
                                    let handleMessage = function (event) {
                                        let origin = event.origin;
                                        // console.log("origin", event.origin);
                                        if (
                                            origin ==
                                            "https://login.dingtalk.com"
                                        ) {
                                            //判断是否来自ddLogin扫码事件。
                                            let loginTmpCode = event.data;
                                            //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
                                            // console.log("loginTmpCode", loginTmpCode);
                                            let url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=snsapi_login&state=${vm.connectAuthRenderData.data.state}&redirect_uri=${vm.connectAuthRenderData.data.redirectUri}&loginTmpCode=${loginTmpCode}`;
                                            // console.log('redirect social url',url);
                                            window.location.href = url;
                                            return true;
                                        }
                                    };
                                    if (
                                        typeof window.addEventListener !=
                                        "undefined"
                                    ) {
                                        window.addEventListener(
                                            "message",
                                            handleMessage,
                                            false
                                        );
                                    } else if (
                                        typeof window.attachEvent != "undefined"
                                    ) {
                                        window.attachEvent(
                                            "onmessage",
                                            handleMessage
                                        );
                                    }
                                });
                            }
                        } else if (source === SOCIAL_VENDOR_QLINYUN) {
                            let url = encodeURIComponent(
                                vm.connectAuthRenderData.data.redirectUri
                            );
                            let scope = "";
                            let goto =
                                `https://cas.qlinyun.com/cas/oauth2.0/authorize?client_id=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                url;
                            window.location.href = goto;
                            return true;
                        } else if (source === SOCIAL_VENDOR_QLINYUNDEV) {
                            let url = encodeURIComponent(
                                vm.connectAuthRenderData.data.redirectUri
                            );
                            let scope = "";
                            let goto =
                                `https://cas.back.qlinyun.com:9443/cas/oauth2.0/authorize?client_id=${vm.connectAuthRenderData.data.clientId}&response_type=code&scope=${scope}&state=${vm.connectAuthRenderData.data.state}&redirect_uri=` +
                                url;
                            window.location.href = goto;
                            return true;
                        }
                    } else {
                        vm.$Message.error({
                            content: vm.connectAuthRenderData.message,
                            duration: 7,
                        });
                        return false;
                    }
                } else {
                    this.auto = false;
                    vm.$Message.error("尚未完工，敬请期待");
                    return false;
                }
            }
        },
        async disconnectSocialAccount(source) {
            let token = this.getUserToken();
            if (!!token) {
                if (
                    source === SOCIAL_VENDOR_DINGTALK ||
                    source === SOCIAL_VENDOR_QLINYUN ||
                    source === SOCIAL_VENDOR_QLINYUNDEV
                ) {
                    let disconnectResult = {};
                    try {
                        disconnectResult = await HttpSocialAuthUnbindSource(
                            source,
                            window.location.host,
                            {
                                bindToken: token,
                            }
                        );
                    }
                    catch (err) {
                        this.$Message.error({
                            content: err.message,
                            duration: 7,
                        });
                    }
                    this.auto = false;
                    if (disconnectResult.code === 200) {
                        if (source === SOCIAL_VENDOR_DINGTALK) {
                            this.connectionsMap.source.dingtalk.bound = false;
                            this.connectionsMap.source.dingtalk.nickname = "";
                            this.connectionsMap.source.dingtalk.username = "";
                        } else if (source === SOCIAL_VENDOR_QLINYUN) {
                            this.connectionsMap.source.qlinyun.bound = false;
                            this.connectionsMap.source.qlinyun.nickname = "";
                            this.connectionsMap.source.qlinyun.username = "";
                        } else if (source === SOCIAL_VENDOR_QLINYUNDEV) {
                            this.connectionsMap.source.qlinyundev.bound = false;
                            this.connectionsMap.source.qlinyundev.nickname = "";
                            this.connectionsMap.source.qlinyundev.username = "";
                        } else if (source === SOCIAL_VENDOR_WECHAT) {
                            this.connectionsMap.source.wechat.bound = false;
                            this.connectionsMap.source.wechat.nickname = "";
                            this.connectionsMap.source.wechat.username = "";
                        }
                        this.$Message.success({
                            content: this.$t(
                                "port.connections.action_disconnect_success"
                            ),
                            duration: 7,
                        });
                    } else {
                        this.$Message.error({
                            content: disconnectResult.message,
                            duration: 7,
                        });
                    }
                } else {
                    this.$Message.error("尚未完工，敬请期待");
                }
            }
        },
        async getUserSocialConnections() {
            let token = this.getUserToken();
            let connectionsResult = {};
            if (!!token) {
                try {
                    connectionsResult = await HttpSocialAuthBound(
                        window.location.host,
                        {
                            bindToken: token,
                        }
                    );
                } catch (err) {
                    connectionsResult.message = err.message;
                }
                this.auto = false;
                if (connectionsResult.code === 200) {
                    const connectionsResultData = connectionsResult.data;
                    if (
                        connectionsResultData.dingtalk &&
                        connectionsResultData.dingtalk.uuid
                    ) {
                        this.connectionsMap.source.dingtalk.bound = true;
                        this.connectionsMap.source.dingtalk.nickname =
                            connectionsResultData.dingtalk.nickname;
                        this.connectionsMap.source.dingtalk.username =
                            connectionsResultData.dingtalk.username;
                    } else if (
                        connectionsResultData.wechat &&
                        connectionsResultData.wechat.uuid
                    ) {
                        this.connectionsMap.source.wechat.bound = true;
                        this.connectionsMap.source.wechat.nickname =
                            connectionsResultData.wechat.nickname;
                        this.connectionsMap.source.wechat.username =
                            connectionsResultData.wechat.username;
                    } else if (
                        connectionsResultData.qlinyun &&
                        connectionsResultData.qlinyun.uuid
                    ) {
                        this.connectionsMap.source.qlinyun.bound = true;
                        this.connectionsMap.source.qlinyun.nickname =
                            connectionsResultData.qlinyun.nickname;
                        this.connectionsMap.source.qlinyun.username =
                            connectionsResultData.qlinyun.username;
                    } else if (
                        connectionsResultData.qlinyundev &&
                        connectionsResultData.qlinyundev.uuid
                    ) {
                        this.connectionsMap.source.qlinyundev.bound = true;
                        this.connectionsMap.source.qlinyundev.nickname =
                            connectionsResultData.qlinyundev.nickname;
                        this.connectionsMap.source.qlinyundev.username =
                            connectionsResultData.qlinyundev.username;
                    } else if (
                        connectionsResultData.wechat_open &&
                        connectionsResultData.wechat_open.uuid
                    ) {
                        this.connectionsMap.source.wechat_open.bound = true;
                        this.connectionsMap.source.wechat_open.nickname =
                            connectionsResultData.wechat_open.nickname;
                        this.connectionsMap.source.wechat_open.username =
                            connectionsResultData.wechat_open.username;
                    } else if (
                        connectionsResultData.wechat_mp &&
                        connectionsResultData.wechat_mp.uuid
                    ) {
                        this.connectionsMap.source.wechat_mp.bound = true;
                        this.connectionsMap.source.wechat_mp.nickname =
                            connectionsResultData.wechat_mp.nickname;
                        this.connectionsMap.source.wechat_mp.username =
                            connectionsResultData.wechat_mp.username;
                    }
                } else {
                    this.$Message.error({
                        content: connectionsResult.message,
                        duration: 7,
                    });
                }
            } else {
                this.auto = false;
            }
        },
    },
};
</script>
